import '.ch{font-size:1.125rem;}.ssr-plugin'
import '.eo{line-height:1.75rem;}.ssr-plugin'
import '.ej{text-decoration:none;}.ssr-plugin'
import '.fv{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="ch eo"
    >
      {translations.privacySubtitle}{' '}
      <a className="ej fv"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="ej fv"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
